module.exports = __webpack_public_path__ + "static/media/price-up.250f2f33.svg";